import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceCommissionById, setFinanceCommissionStatus } from '@/api/financial-center'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { Loading } from 'element-ui'
import {delNullProperty} from "@/utils";
@Component({})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyInfo: any = ''
    financeBackMoneyDetailList = []
    status: number = null
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    opinion = '' // 审批意见
    cancleReview = false
    reviewDialog = false
    fileList = []
    fileList1 = []
    turnParagraphArr = []
    moneyCertificatesArr = []
    addDataList: any

    editFileList = []
    editFiles = {
        isBackStudentContract: null,
        isBackAgentContract: null,
        financeCommissionProofList: null,
    }
    isRequired = true
    editFileRequired = false

    buttonDisabled = false
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    previewVisible = false
    previewVisible1 = false
    previewPath = ''
    previewPath1 = ''
    previewName = ''
    previewName1 = ''
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    financeCommissionAccount= {}
    accountType = ''

    get orderAllPrice() {
        let num = 0
        if(this.backMoneyInfo.financeCommissionDetailList){
            this.backMoneyInfo.financeCommissionDetailList.map(item => num += Number(item.priceSum))
        }
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo.financeCommissionProofList.map(item => item.url)
    }
    get turnParagraphUrl() {//转款
        return this.turnParagraphArr.map(item => item.url)
    }
    get moneyCertificatesUrl() {//打款
        return this.moneyCertificatesArr.map(item => item.url)
    }
    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    created() {
        this.approval_id = Number(this.$route.query.approval_id)
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMessageReviewById()
        this.approval_type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string

    }

    formatDate = formatDate
    async getMessageReviewById() {
        const data: any = await getMessageReviewById(this.approval_id,this.types)
        this.editFileList = data.result.editFileList || []
        this.editFileList.forEach(item => {
            this.editFiles[item.file] = data.result[item.file]
        })
        this.editFiles.isBackStudentContract = (this.editFiles.isBackStudentContract == "是") ? '1':'0'
        this.editFiles.isBackAgentContract = (this.editFiles.isBackAgentContract == "是") ? '1':'0'
        this.backMoneyInfo = data.result
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.backMoneyInfo.financeCommissionProofList.map(item => {
            // 转款凭证
            if(item.types == '1'){
                this.turnParagraphArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
            // 打款凭证
            if(item.types == '0'){
                this.moneyCertificatesArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
        })
        this.stepNode.isFirstNode = this.backMoneyInfo.isFirstNode
        this.stepNode.isSyncEkuaibao = this.backMoneyInfo.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.backMoneyInfo.isSyncEqianbao
        this.financeCommissionAccount = this.backMoneyInfo.financeCommissionAccount
        this.accountType = (this.financeCommissionAccount as any).type
    }
    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.approval_type !== '0') return false
        return this.editFileList.some(item => item.cnFile === key)
    }
    // 撤回审批cancleReview
    async cancleReviewDialogConfirm() {
        await setFinanceCommissionStatus({ id: Number(this.backMoneyInfo.id), action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }
    // 通过
    // 1通过 2驳回
    openReviewDialog(status: number) {
        if(this.backMoneyInfo.directorDepartmentlName == '财务部'){
            if(this.fileList.length === 0) { this.$message.error('财务请上传打款凭证'); return }
        }
        this.status = status
        this.approvedVisible = true
    }
    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    // 通过 -- 审批通过中 驳回 - 审批驳回中
    reviewDialogConfirm() {

        const newObj: any = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
        }

        if(this.isRequired) {
            let bol = false
            for(const key in newObj) {
                if(['', null, undefined].includes(newObj[key])) {
                    bol = true
                    break;
                } else {
                    bol = false
                }
            }
            if(bol) {
                this.$message.error('请将编辑信息填写完整')
                return
            }
        }
        // newObj.payeeInfoId = this.backMoneyInfo.financeCommissionAccount ? this.backMoneyInfo.financeCommissionAccount.payeeInfoId : ''
        newObj.financeCommissionProofList = [...this.moneyCertificatesArr, ...this.turnParagraphArr]
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            nodeType: this.nodeType ? this.nodeType : '',
            isSync: this.isSync ? this.isSync : '',
            // isRevoke: this.isAgreeRevoke ? this.isAgreeRevoke : ''
        }

        this.buttonDisabled = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })

        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            loading.close()
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            loading.close()
            console.log(err)
            this.buttonDisabled = false
        })
    }

    // 通过
    approvedConfirm() {

        const newObj: any = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
        }

        if(this.isRequired) {
            let bol = false
            for(const key in newObj) {
                if(['', null, undefined].includes(newObj[key])) {
                    bol = true
                    break;
                } else {
                    bol = false
                }
            }
            if(bol) {
                this.$message.error('请将编辑信息填写完整')
                return
            }
        }
        // newObj.payeeInfoId = this.backMoneyInfo.financeCommissionAccount ? this.backMoneyInfo.financeCommissionAccount.payeeInfoId : ''
        newObj.financeCommissionProofList = [...this.moneyCertificatesArr, ...this.turnParagraphArr]
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            // nodeType: this.nodeType ? this.nodeType : '',
            // isSync: this.isSync ? this.isSync : '',
            isRevoke: this.isAgreeRevoke ? this.isAgreeRevoke : ''
        }
        this.buttonDisabled = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })

        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            loading.close()
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            loading.close()
            console.log(err)
            this.buttonDisabled = false
        })
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.moneyCertificatesArr.push({ name: data.name, url: data.ossUrl, types: '0' })
    }
    uploadSuccess1(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.turnParagraphArr.push({ name: data.name, url: data.ossUrl, types: '1'  })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    uploadError1() {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    handlePreview1(file) {
        this.previewPath1 = file.url
        this.previewName1 = file.name
        this.previewVisible1 = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handleUploadRemove1(file) {
        this.fileList1 = this.fileList1.filter(item => item.uid !== file.uid)
    }



    // 驳回审批
    clickRejectButton(status: number) {
        // this.stepNode.approvalStatus = status
        this.status = status
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

    //    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.opinion = data.reviewIdea
        this.isSync = data.isTouchE
        this.approvalVisible = false
        this.reviewDialogConfirm()
    }


    /*
 * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.opinion = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }

}
